<template>
	<!-- User Menu -->
	<li class="nav-item dropdown">
		<a
			href="javascript:void(0)"
			class="user-link nav-link"
			data-bs-toggle="dropdown"
		>
			<span class="user-img">
				<img v-if="user.image" :src="user.image" alt="" class="profilesidebar" />
				<img
					v-else
					src="@/assets/img/profiles/avatar-07.jpg"
					alt=""
					class="profilesidebar"
				/>
				<span class="animate-circle"></span>
			</span>
			<span class="user-content">
				<span class="user-details">Use</span>
				<span class="user-name">{{ user.name }}</span>
			</span>
		</a>
		<div class="dropdown-menu menu-drop-user">
			<div class="profilemenu">
				<div class="subscription-menu">
					<router-link class="dropdown-item" to="/profile"
						><i class="feather feather-user me-1 mt-1"></i> Profile</router-link
					>
					<router-link class="dropdown-item" to="/referrals"
						><i class="feather feather-user-plus me-1 mt-1"></i>
						Referrals</router-link
					>
					<router-link class="dropdown-item" to="/settings"
						><i class="feather feather-settings me-1 mt-1"></i> Settings</router-link
					>
					<router-link class="dropdown-item" to="/subscriptions"
						><i class="feather feather-credit-card me-1 mt-1"></i
						>Subscriptions</router-link
					>
					<router-link class="dropdown-item" to="/membership-plans"
						><i class="feather feather-layers me-1 mt-1"></i>Pricing</router-link
					>
				</div>
				<div class="subscription-logout">
					<a class="dropdown-item text-danger" @click="logoutUser"
						><i class="feather feather-log-out me-1 mt-1"></i> Logout</a
					>
				</div>
			</div>
		</div>
	</li>
	<!-- /User Menu -->
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const router = useRouter();

const user = computed(() => store.getters["auth/user"]);

const getSettings = () => {
	store.dispatch("settings/getSettings");
};

const logoutUser = () => {
	localStorage.clear();
	// window.fcWidget.destroy()
	router.push({ name: "login" });
};

onMounted(() => {
	store.dispatch("auth/getUser");
	getSettings();
});
</script>
